import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";

function PickSection({ title, children, sheet }) {
  if (sheet) {
    return (
      <div className={aa.teamInvitePickSection}>
        <p className={aa.teamInvitePickTitle}>{title}</p>
        <div className={aa.teamInvitePickList}>{children}</div>
      </div>
    );
  }
  return (
    <div className={s.branchCheckGrid} style={{ marginBottom: 16 }}>
      <p className={s.docSectionHint} style={{ gridColumn: "1 / -1", margin: 0 }}>
        {title}
      </p>
      {children}
    </div>
  );
}

function PickItem({ checked, onChange, children, sheet }) {
  if (sheet) {
    return (
      <label
        className={`${aa.teamInvitePickItem} ${
          checked ? aa.teamInvitePickItemOn : ""
        }`}
      >
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className={aa.teamInvitePickLabel}>{children}</span>
      </label>
    );
  }
  return (
    <label className={s.branchCheckItem}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span>{children}</span>
    </label>
  );
}

export default function TrainerAssignmentsFields({
  directions = [],
  groups = [],
  directionIds = [],
  groupIds = [],
  onToggleDirection,
  onToggleGroup,
  sheet = false,
}) {
  const hintClass = sheet ? aa.hubHint : s.docSectionHint;

  if (!directions.length && !groups.length) {
    return sheet ? (
      <p className={hintClass}>Сначала добавьте направления и группы в разделе «Группы».</p>
    ) : null;
  }

  return (
    <>
      {directions.length > 0 ? (
        <PickSection title="Направления" sheet={sheet}>
          {directions.map((d) => (
            <PickItem
              key={d.id}
              sheet={sheet}
              checked={directionIds.includes(d.id)}
              onChange={() => onToggleDirection(d.id)}
            >
              {d.name}
            </PickItem>
          ))}
        </PickSection>
      ) : null}

      {groups.length > 0 ? (
        <PickSection title="Группы" sheet={sheet}>
          {groups.map((g) => (
            <PickItem
              key={g.id}
              sheet={sheet}
              checked={groupIds.includes(g.id)}
              onChange={() => onToggleGroup(g.id)}
            >
              {g.name}
              {g.sport_direction ? (
                <span className={aa.teamInvitePickMeta}>{g.sport_direction}</span>
              ) : null}
            </PickItem>
          ))}
        </PickSection>
      ) : null}
    </>
  );
}

export function toggleId(list, id) {
  return list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
}
